// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const ChevronUpIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M16 15a1 1 0 01-.71-.29L12 11.41l-3.29 3.3a1 1 0 11-1.42-1.42l4-4a1 1 0 011.42 0l4 4a1 1 0 010 1.42A1 1 0 0116 15z" fill="currentColor"/></svg>'} />;

ChevronUpIcon.displayName = 'ChevronUpIcon';

export default ChevronUpIcon;
